import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { contentClick, loadMoreInteraction } from '../../../../../helpers/datalayer-utils';
import { makeApiCall, widgetLink } from '../../../../../helpers/utils';
import { BQLink } from '../../../../atoms/bqlink';
import {
  ArrowRightIcon,
  FileChartOutlineIcon,
  FourStarIcon,
} from '../../../../atoms/material-icons';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import './stock-news.m.css';

const StockNews = (props) => {
  const widgetParam = props?.widget ? '?view=apps' : '';
  const [stockNews, setStockNews] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [companyName, setCompanyName] = useState('');
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );

  const getStockNews = async () => {
    const stockId = fetchStockId();
    const stockDetailsResponse = await fetch(`/next/feapi/stock/stock-details/${stockId}`);
    const stockDetailsData = await stockDetailsResponse.json();
    const stockArray = stockDetailsData?.filter(
      (stock) => stock?.STOCKID?.toString() === fetchStockId(),
    );

    const encodedTag = encodeURIComponent(stockArray[0]?.COMPNAME);
    const response = await makeApiCall(`${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&allfields=${encodedTag}&pagesize=4`);
    setStockNews(response?.results || []);
    setCompanyName(stockArray[0]?.COMPNAME);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
      getStockNews();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getStockNews();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="markets-news-container">
      <div styleName="header-title-container">
        <FileChartOutlineIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">STOCK NEWS</h2>
      </div>
      {stockNews?.length === 0 || stockNews?.length < 2 ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      ) : (
        <>
          {stockNews?.slice(0, 1).map((news, index) => (
            <BQLink href={new URL(news?.link).pathname} key={index}>
              <div styleName="image-container">
                <img src={news?.thumb_image + '?downsize=400:264'} alt="thumb image" styleName="thumb-image" />
                <h2 styleName="image-overlay">{news?.title}
                  {news?.tags?.includes('Research Reports') && (
                    <span className="exclusive-icon">
                      <FourStarIcon color="#CE9445" size="14px" />
                    </span>
                  )}
                </h2>
              </div>
            </BQLink>
          ))}
          <div styleName="news-container">
            {stockNews?.slice(1, 4).map((news, index) => (
              <p
                styleName="news-item"
                key={index}
                onClick={() => contentClick(userData, news, pageType)}
              >
                <BQLink href={new URL(news?.link).pathname} styleName="news-headline">
                  {news?.title}
                </BQLink>
                <span styleName="author-name">
                  {news?.['author_byline']}
                  {news?.tags?.includes('Research Reports') && (
                    <span className="exclusive-icon">
                      <FourStarIcon color="#CE9445" size="14px" />
                    </span>
                  )}
                </span>
              </p>
            ))}
            <div
              styleName="btn-container"
              onClick={() =>
                loadMoreInteraction('Show All Stock News', userData, pageType, 'stock news')
              }
            >
              <BQLink
                styleName="market-news-btn"
                href={widgetLink(
                  `topic/${companyName
                    .toLowerCase()
                    .trim()
                    .replaceAll(' ', '-')
                    .split('-')
                    .filter((val) => val !== '')
                    .map((val) => val.replaceAll('.', ''))
                    .join('-')}${widgetParam}`,
                  props?.widget,
                )}
                target="_blank"
                rel="noreferrer"
              >
                Show All Stock News <ArrowRightIcon color={'#d01e51'} styleName="tab-icon" />
              </BQLink>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

StockNews.propTypes = {
  currentStock: PropTypes.object,
};

export default StockNews;
